export enum RadioGroupButtonStyle {
    Outline = 'outline',
    Solid = 'solid'
}
